import { render, staticRenderFns } from "./GraphModalComponent.vue?vue&type=template&id=672549d6&scoped=true"
import script from "./GraphModalComponent.vue?vue&type=script&lang=js"
export * from "./GraphModalComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "672549d6",
  null
  
)

export default component.exports